import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import ProductCard from "../card/ProductCard";
import { listProduct, searchFilters } from "../function/product";
import { listCategory } from "../function/category";
import { listCategoryService } from "../function/categoryservice"; // ใช้สำหรับสินค้าบริการ
import { useLocation } from "react-router-dom";
import { Slider, Select } from "antd";
import LocationServiceChecker from "./LocationServiceChecker";
import Footer from "../layouts/Footer";
import "./Shop.css";
import axios from "axios";

const { Option } = Select;

const ShopOrigi = () => {
  const [product, setProduct] = useState([]);
  const [loading, setLoading] = useState(false);
  const [price, setPrice] = useState([0, 0]);
  const [ok, setOk] = useState(false);
  const [category, setCategory] = useState([]);
  const [categorySelect, setCategorySelect] = useState([]);
  const [categoryType, setCategoryType] = useState("");

  const { search } = useSelector((state) => ({ ...state }));
  const { text } = search;

  const location = useLocation();

  const [userLocation, setUserLocation] = useState(null);
  const [serviceCenters, setServiceCenters] = useState([]);
  const [sortedServiceCenters, setSortedServiceCenters] = useState([]);

  // ฟังก์ชันโหลดข้อมูลสินค้า
  const loadData = () => {
    setLoading(true);
    listProduct(100)
      .then((res) => {
        setProduct(res.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const fetchDataFilter = (arg) => {
    searchFilters(arg).then((res) => {
      setProduct(res.data);
    });
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
        }
      );
    }
  }, []);

  useEffect(() => {
    const fetchServiceCenters = async () => {
      let url = `${process.env.REACT_APP_API}/service-centers`;
      if (categorySelect.length > 0) {
        url += `?categoryId=${categorySelect[0]}`;
      }
      const { data } = await axios.get(url);
      setServiceCenters(data);
      // ถ้าไม่มีข้อมูล ให้ reset sortedServiceCenters ทันที
      if (!data || data.length === 0) {
        setSortedServiceCenters([]);
      }
    };
    if (categorySelect.length === 0) {
      setServiceCenters([]);
      setSortedServiceCenters([]);
    } else {
      fetchServiceCenters();
    }
  }, [categorySelect]);

  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    function deg2rad(deg) {
      return deg * (Math.PI / 180);
    }
    const R = 6371; // km
    const dLat = deg2rad(lat2 - lat1);
    const dLon = deg2rad(lon2 - lon1);
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }
  useEffect(() => {
    if (userLocation && serviceCenters.length > 0) {
      const sorted = [...serviceCenters].map(center => ({
        ...center,
        distance: getDistanceFromLatLonInKm(
          userLocation.latitude,
          userLocation.longitude,
          center.location.latitude,
          center.location.longitude
        )
      }))
        .sort((a, b) => a.distance - b.distance);
      setSortedServiceCenters(sorted);
    } else {
      setSortedServiceCenters([]); // ต้อง reset ตรงนี้ด้วย
    }
  }, [userLocation, serviceCenters]);

  // ตรวจสอบ query parameters เมื่อ URL เปลี่ยน
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const categoryFromUrl = params.get("category");
    const categoryTypeFromUrl = params.get("categoryType");

    if (categoryTypeFromUrl && categoryTypeFromUrl === "360") {
      listCategory().then((res) => {
        setCategory(res.data);

        // ตรวจสอบหมวดหมู่ที่ได้รับจาก URL และกรองสินค้าตาม ID
        const categoryIds = {
          'supplement-for-health': '666cfc1691472649211207f5',
          'beauty-supplements': '666d097b25462c519c2685fe',
          'personal-care-hygiene': '666d205a25462c519c268653',
          'organic-natural-products': '66f7a06eacfb993d2ef594a4',
          'fitness-performance': 'another-id-4',
          'home-living': 'another-id-5',
          'health-wellness': 'another-id-6'
        };

        // หากหมวดหมู่ตรงกับใน `categoryIds` ให้กรองสินค้า
        const selectedCategoryId = categoryIds[categoryFromUrl];
        if (selectedCategoryId) {
          setCategorySelect([selectedCategoryId]);
          fetchDataFilter({ category: selectedCategoryId });
        }
      });
    } else if (categoryTypeFromUrl === "service") {
      // ดึงข้อมูลหมวดหมู่สินค้าบริการ
      listCategoryService().then((res) => {
        setCategory(res.data);

        const categoryIds = {
          rehabilitation: "66c5a9fff9f03b44e0978a2b",
          medicalspa: "66cd5ade24b0335c5300dc8c",
          aesthetics: "675c1542814f4f6f175fe8ab",
          "anti-aging": "66c5934ef9f03b44e0978625",
          "hotels-booking": "66c5934ef9f03b44e0978625",
          "yoo-en-care": "66cd5ade24b0335c5300dc8c",
          "dreamlab": "66c5aa10f9f03b44e0978a2f",
          "le-dream-aesthetics": "675c1542814f4f6f175fe8ab",
        };

        const selectedCategoryId = categoryIds[categoryFromUrl];
        if (selectedCategoryId) {
          setCategorySelect([selectedCategoryId]);
          fetchDataFilter({ category: selectedCategoryId });
        }
      });
    } else {
      setCategorySelect([]);
      console.log("Invalid category type");
    }
  }, [location.search]);

  // ฟังก์ชันกรองสินค้าตามราคาที่เลือก
  useEffect(() => {
    fetchDataFilter({ price });
  }, [ok]);

  // เมื่อหมวดหมู่เปลี่ยนแปลงให้ทำการกรองข้อมูล
  const handleCategoryChange = (value) => {
    setCategorySelect(value);
    if (value.length > 0) {
      fetchDataFilter({ category: value });
    } else {
      loadData();
    }
  };

  const handlePrice = (value) => {
    setPrice(value);
    setTimeout(() => {
      setOk(!ok);
    }, 300);
  };

  const handleCategoryTypeChange = (value) => {
    setCategoryType(value);
    if (value === "360") {
      listCategory().then((res) => setCategory(res.data));
    } else if (value === "service") {
      listCategoryService().then((res) => setCategory(res.data));
    }
    setCategorySelect([]); // Reset the selected category
  };

  return (
    <>
      
      <div className="container-fluid ">
        <div className="row mt-1">
          <div
            className="col-md-2"
            style={{ backgroundColor: "#e1f8cd33", padding: "10px" }}
          >
            Filter / Search
            <hr />
            <h4>ค้นหาด้วยราคา</h4>
            <Slider value={price} onChange={handlePrice} range max={50000} />
            <hr />
            <h4>ประเภทหมวดหมู่</h4>
            <Select
              style={{ width: "100%" }}
              value={categoryType}
              onChange={handleCategoryTypeChange}
            >
              <Option value="360">หมวดหมู่ของสินค้า 360</Option>
              <Option value="service">หมวดหมู่สินค้าบริการ</Option>
            </Select>
            <hr />
            <h4>ค้นหาตามหมวดหมู่</h4>
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              value={categorySelect}
              onChange={handleCategoryChange}
            >
              {category.map((item) => (
                <Option key={item._id} value={item._id}>
                  {item.name}
                </Option>
              ))}
            </Select>
          </div>
          <div className="col-md-9 d-flex flex-column justify-content-start align-items-stretch align-self-start mt-5">
            <div className="row mt-1">
              <LocationServiceChecker />
            </div>
            
            {loading ? (
              <h4 className="text-danger">Loading...</h4>
            ) : (
              <h4 className="text-info">Product</h4>
            )}

            {product.length < 1 && <p>No Product found</p>}

            <div className="row pb-1 g-1  mt-1">
              
              {product.map((item, index) => (
                <div
                  key={index}
                  className="col-6 col-sm-6 col-md-4 col-lg-3 mb-4  "
                >
                  <ProductCard product={item} />
                </div>
              ))}
            </div>
            <div className="row">
              {sortedServiceCenters && sortedServiceCenters.length > 0 && (
                <div>
                  <h5>จุดบริการใกล้คุณ</h5>
                  <ul>
                    {sortedServiceCenters.slice(0, 1).map(center => (
                      <li key={center._id}>
                        {center.name} ({center.province}) - {center.distance ? center.distance.toFixed(2) : ""} กม.
                        <div style={{ margin: '10px 0' }}>
                          <iframe
                            width="80%"
                            height="200"
                            frameBorder="0"
                            style={{ border: 0 }}
                            src={`https://www.google.com/maps?q=${center.location.latitude},${center.location.longitude}&hl=th&z=16&output=embed`}
                            allowFullScreen
                            title={`map-${center._id}`}
                          ></iframe>
                        </div>
                      </li>
                    ))}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ShopOrigi;
